// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./src/css/slider.css
 ** module id = 12
 ** module chunks = 1
 **/